import Resource from "@/models/Resource";

export default class AssignedResource extends Resource {
    resource() {
        return "assigned/resources";
    }

    baseURL() {
        return "https://" + window.location.host + import.meta.env.VITE_API_PATH;
    }
}
